import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { NAV } from "@/constants/testIds";

const links = [
  { to: "/", label: "Home", key: "landing" },
  { to: "/jobs", label: "Marketplace", key: "jobs" },
  { to: "/learning", label: "Learning", key: "learning" },
  { to: "/mentors", label: "Mentors", key: "mentors" },
  { to: "/contact", label: "Contact", key: "contact" },
];

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/80 border-b border-[color:var(--f2-border)]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid={NAV.logo} className="flex items-center gap-2">
          <span className="w-6 h-6 border border-[color:var(--f2-saffron)] flex items-center justify-center">
            <span className="w-2 h-2 bg-[color:var(--f2-saffron)]" />
          </span>
          <span className="font-display font-black tracking-tight text-lg">
            FORTE<sup className="saffron">2</sup> SPACE
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.key}
              to={l.to}
              data-testid={NAV[l.key]}
              className={`label-xs hover:text-white transition-colors ${loc.pathname === l.to ? "text-white" : ""}`}
            >
              {l.label}
            </Link>
          ))}
          {user && (
            <Link to="/dashboard" data-testid={NAV.dashboard} className="label-xs hover:text-white transition-colors">
              Dashboard
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <div className="flex items-center gap-3" data-testid={NAV.userMenu}>
              <span className="hidden sm:block label-xs">{user.name || user.email}</span>
              <button
                data-testid={NAV.logout}
                className="btn-crisp"
                onClick={async () => { await logout(); nav("/"); }}
              >
                Logout
              </button>
            </div>
          ) : (
            <button
              data-testid={NAV.login}
              className="btn-crisp btn-primary"
              onClick={() => nav("/login")}
            >
              Sign In
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
